const NOTICE_SELECTOR = "[data-profile-global-notice]";
const DISMISS_AFTER_MS = 6000;

function dismissNotice(notice) {
  if (!notice || notice.dataset.noticeDismissed) return;

  notice.dataset.noticeDismissed = "true";
  notice.classList.add("opacity-0");
  setTimeout(() => notice.remove(), 300);
}

document.addEventListener("click", (event) => {
  if (!event.target.closest("[data-profile-global-notice-close]")) return;

  dismissNotice(event.target.closest(NOTICE_SELECTOR));
});

function initializeGlobalNotice() {
  const notice = document.querySelector(NOTICE_SELECTOR);
  if (!notice || notice.dataset.noticeTimer) return;

  notice.dataset.noticeTimer = "true";
  setTimeout(() => dismissNotice(notice), DISMISS_AFTER_MS);
}

document.addEventListener("turbo:load", initializeGlobalNotice);
document.addEventListener("pageshow", initializeGlobalNotice);
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeGlobalNotice);
} else {
  initializeGlobalNotice();
}
